import { SafeArea } from '@capacitor-community/safe-area';
import { useEffect } from 'react';

import { isNativePlatform } from '../capacitor/appsHelpers';
import useLocalStorage from './useLocalStorage';

const useTheme = () => {
  const [theme, setTheme] = useLocalStorage('theme', 'light');

  const setStatusBarStyleDark = async () => {
    await SafeArea.setSystemBarsStyle({
      style: 'dark',
    });
  };

  const setStatusBarStyleLight = async () => {
    await SafeArea.setSystemBarsStyle({
      style: 'light',
    });
  };

  const toggleStatusBar = async () => {
    if (isNativePlatform()) {
      try {
        theme === 'light'
          ? await setStatusBarStyleLight()
          : await setStatusBarStyleDark();
      } catch {
        // do nothing
      }
    }
  };

  const toggleTheme = async () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    toggleStatusBar();
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return {
    theme,
    toggleTheme,
  };
};

export default useTheme;
